$(document).ready(function(){
	detailSlider();
});

$(function(){
	$(document).on("click", "#addPicklist", function(){
		var itemId = $("input[name='item_id']").val();
		addPicklist(itemId);
		return false;
	});

	$(document).on("click", "#removePicklist", function(){
		var itemId = $("input[name='item_id']").val();
		removePicklist(itemId);
		return false;
	});

	$(document).on("click", "#addFavorite", function(){
		var itemId = $("input[name='item_id']").val();
		addFavorite(itemId);
		return false;
	});

	$(document).on("click", "#removeFavorite", function(){
		var itemId = $("input[name='item_id']").val();
		removeFavorite(itemId);
		return false;
	});
});


function addPicklist(itemId){
	$.ajax({
		type: "POST",
		data: {
			itemId: itemId,
		},
		url: '/jewelry/picklist/add',
		beforeSend: function(){
		},
		success: function(response){
			if(response.status){
				$("#addPicklist").replaceWith('<a href="#" id="removePicklist" class="btn pk shadow fs-14">借りたいものリスト登録済み</a>');
			}else{
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown){
			console.log("An error occured. : " + textStatus + " : " + errorThrown);
		}
	});
}


function removePicklist(itemId){
	$.ajax({
		type: "POST",
		data: {
			itemId: itemId,
		},
		url: '/jewelry/picklist/remove',
		beforeSend: function(){
		},
		success: function(response){
			if(response.status){
				$("#removePicklist").replaceWith('<a href="#" id="addPicklist" class="btn pk submit shadow fs-14">借りたいものリストに入れる</a>');
			}else{
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown){
			console.log("An error occured. : " + textStatus + " : " + errorThrown);
		}
	});
}


function addFavorite(itemId){
	$.ajax({
		type: "POST",
		data: {
			itemId: itemId,
		},
		url: '/jewelry/favorite/add',
		beforeSend: function(){
		},
		success: function(response){
			if(response.status){
				$("#addFavorite").replaceWith('<a href="#" id="removeFavorite" class="btn pk shadow fs-14">お気に入り登録済み</a>');
			}else{
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown){
			console.log("An error occured. : " + textStatus + " : " + errorThrown);
		}
	});
}


function removeFavorite(itemId){
	$.ajax({
		type: "POST",
		data: {
			itemId: itemId,
		},
		url: '/jewelry/favorite/remove',
		beforeSend: function(){
		},
		success: function(response){
			if(response.status){
				$("#removeFavorite").replaceWith(' <a href="#" id="addFavorite" class="btn pk shadow fs-14">お気に入りに入れる</a>');
			}else{
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown){
			console.log("An error occured. : " + textStatus + " : " + errorThrown);
		}
	});
}


function detailSlider() {
	$('.mainslider').slick({
		dots: false,
		arrow: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.thumbslider'
	})

	$('.thumbslider').slick({
		dots: false,
		arrow: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: '.mainslider',
		focusOnSelect: true
	})
}

//$( function() {
//	detailSlider();
//})